import { FieldConfig } from '../../common/field-types';
import { renderRateScheduleField } from '../_shared';
import {
  COMPENSATION_PLAN_OPTIONS,
  GENDER_OPTIONS,
  InsuredUniversityFormValues,
  PAYMENT_PERIODICITY_OPTIONS,
  RATE_MODE_OPTIONS,
  isFixedRate,
  isSteppedRate,
  SAVINGS_MODE_OPTIONS,
} from './schema';

const CLIENTE = 'Datos del cliente';
const POLIZA = 'Detalle de la póliza';
const CAPITALES = 'Capitales';
const MODO = 'Modo y campos específicos';
const APORTES = 'Aportes y primas';

const isCapacityMode = (v: InsuredUniversityFormValues) => v.savings_mode === 'savings_capacity';

// eslint-disable-next-line max-len
export const INSURED_UNIVERSITY_FIELDS: readonly FieldConfig<InsuredUniversityFormValues>[] = [
  {
    key: 'date_of_birth', label: 'Fecha de nacimiento', kind: 'date', section: CLIENTE,
  },
  {
    key: 'gender', label: 'Género', kind: 'select', options: GENDER_OPTIONS, section: CLIENTE,
  },
  {
    key: 'compensation_plan', label: 'Plan de compensación', kind: 'select', options: COMPENSATION_PLAN_OPTIONS, section: POLIZA,
  },
  {
    key: 'payment_periodicity', label: 'Periodicidad de pago', kind: 'select', options: PAYMENT_PERIODICITY_OPTIONS, section: POLIZA,
  },
  {
    key: 'death_insured_capital', label: 'Capital muerte', kind: 'number', hint: 'UF (300 - 20.000)', colClassName: 'col-md-6', section: CAPITALES,
  },
  {
    key: 'accidental_death_insured_capital', label: 'Capital muerte accidental', kind: 'number', hint: 'UF (= capital muerte o 0)', colClassName: 'col-md-6', section: CAPITALES,
  },
  {
    key: 'itp_insured_capital', label: 'Capital ITP', kind: 'number', hint: 'UF (= capital muerte o 0)', colClassName: 'col-md-6', section: CAPITALES,
  },
  {
    key: 'serious_illness_insured_capital', label: 'Capital enf. graves', kind: 'number', hint: 'UF (40% del capital muerte o 0)', colClassName: 'col-md-6', section: CAPITALES,
  },
  {
    key: 'savings_mode', label: 'Modo de ahorro', kind: 'select', options: SAVINGS_MODE_OPTIONS, section: MODO,
  },
  {
    key: 'rate_mode', label: 'Modo de tasa', kind: 'select', options: RATE_MODE_OPTIONS, section: MODO,
  },
  {
    key: 'projection_rate', label: 'Tasa de proyección', kind: 'number', hint: 'Anual, ej. 0.0331', step: 0.0001, visibleWhen: isFixedRate, section: MODO,
  },
  {
    key: 'projection_rate_schedule',
    label: 'Tramos de tasa',
    kind: 'custom',
    hint: 'Cada tramo aplica hasta el mes "Hasta" inclusive. El último puede dejarse "para siempre".',
    visibleWhen: isSteppedRate,
    render: renderRateScheduleField,
    section: MODO,
  },
  {
    key: 'agreed_premium', label: 'Prima convenida', kind: 'number', hint: 'UF por período (mínimo: prima básica + 1)', visibleWhen: isCapacityMode, section: APORTES,
  },
  {
    key: 'initial_contribution', label: 'Aporte inicial', kind: 'number', hint: 'UF (aterriza en el inicio de la póliza)', section: APORTES,
  },
  {
    key: 'unscheduled_annual_contribution', label: 'Aporte anual extra', kind: 'number', hint: 'UF', section: APORTES,
  },
  {
    key: 'direct_contribution_amount', label: 'Aporte único', kind: 'number', hint: 'UF (único, con mes propio; adicional al aporte inicial)', colClassName: 'col-md-6', section: APORTES,
  },
  {
    key: 'direct_contribution_month', label: 'Mes del aporte único', kind: 'number', hint: '1 = inicio. Base 1. Se ignora si el aporte es 0.', colClassName: 'col-md-6', section: APORTES,
  },
];
